import React, { useMemo } from 'react';
import { toast } from 'react-toastify';

import {
  QueryCache,
  QueryClient,
  QueryClientProvider as BaseQueryClientProvider,
} from '@tanstack/react-query';

import { OverrideClientType } from '../typings.js';

import QueryClientContext from './QueryClientContext.js';

export interface QueryClientProviderProps<TClient = OverrideClientType> {
  client: TClient;
  children?: React.ReactNode | React.ReactNode[];
}
const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onSuccess: (_, query) => {
      if (query.meta?.successMessage) {
        toast.success(query.meta?.successMessage as string);
      }
    },
    onError: (_, query) => {
      if (query.meta?.errorMessage) {
        toast.error(query.meta.errorMessage as string);
      }
    },
  }),
});

export const QueryClientProvider: React.FC<QueryClientProviderProps<OverrideClientType>> = ({
  client,
  children,
}) => {
  const value = useMemo(() => ({ client }), [client]);
  return (
    <QueryClientContext.Provider value={value}>
      <BaseQueryClientProvider client={queryClient}>{children}</BaseQueryClientProvider>
    </QueryClientContext.Provider>
  );
};

export default QueryClientProvider;
